import { useContext } from "react"
import { useCamper } from "../../ReservationHooks/useCamper"
import { AdminContext } from "~/contexts/AdminContext"
import { useOrderInvoice } from "../../ReservationHooks/useOrderInvoice"
import { usePreviews } from "../../ReservationHooks/usePreviews"
import { serviceRateMode } from "~/api2/orders"
import { EditReservationContext } from "~/contexts/admin/EditReservationContext"
import { STATUSES } from "~/constants/reservation_statuses"

export const useReservationInvoice = () => {
  const { selectedReservation, camp, sites, currentUserRole } = useContext(AdminContext)
  const { setIsDirty } = useContext(EditReservationContext)
  const { data: orderInvoice, refetch } = useOrderInvoice({ orderId: selectedReservation?.order_id })
  const site = sites?.find((s) => s.id === selectedReservation?.site_id) || selectedReservation?.site
  const camper = useCamper({
    camperId: selectedReservation?.camper_id,
  })
  const previews = usePreviews({
    orderId: selectedReservation?.order_id || "",
    campingStyleId: selectedReservation?.selected_camping_style_id || selectedReservation?.site?.camping_style_id,
    discount_type: selectedReservation?.discount_type,
    serviceRate: serviceRateMode.payment_link,
    isPaid:  selectedReservation?.status === STATUSES.PAID,
    includedInvoice: true,
  })

  return {
    camper,
    camp,
    selectedReservation,
    orderInvoice,
    previews,
    refetchPreview: previews.refetch,
    setIsDirty,
    currentUserRole,
    refetch
  }
}
